import { useQueryClient } from "@tanstack/react-query";

import {
  getGetUserProfileQueryKey,
  useSetMultipleConsents,
} from "@/api/generated";

export function useUpdateConsents() {
  const queryClient = useQueryClient();

  return useSetMultipleConsents({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: getGetUserProfileQueryKey(),
        });
      },
    },
  });
}
